import deepCopy from '../../../helpers/deep-copy'

export const CATEGORY_FIELDS = ['categoryT1', 'categoryT2', 'categoryT3']
/**
 * Returns the given categories hierarchy as am object that can be sent as
 * analytics data
 */
function analyticsHierarchy(categoriesHierarchy) {
  const cloned = deepCopy(categoriesHierarchy)

  return cloned
    .reverse()
    .slice(1) // Remove the first products categories
    .reduce(
      (prevValue, curValue, index) =>
        Object.assign(prevValue, { [CATEGORY_FIELDS[index]]: curValue.name }),
      {}
    )
}

export default analyticsHierarchy
